import React from 'react';
import { ShieldCheck } from 'lucide-react';

// Shown in place of the A2P registration wizard for tenants riding the parent
// CIVIX A2P Brand (features.a2p.hideUI === true). No setup is required — SMS
// sending is already enabled through the parent Messaging Service.
//
// variant:
//   • default ('registration') — replaces the A2P registration surfaces.
//   • 'purchase' — shown ABOVE the number-purchase form to explain that the
//     number will be added to the parent CIVIX account at no charge during the
//     testing period (numbers are parent-billed for bypassed tenants).
export default function A2PBypassBanner({ variant = 'registration' }) {
  if (variant === 'purchase') {
    return (
      <div
        data-testid="a2p-bypass-purchase-banner"
        className="panel p-5 flex items-start gap-3 border-emerald-500/30 bg-emerald-500/5"
      >
        <ShieldCheck className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
        <div>
          <div className="font-semibold">No charge during testing</div>
          <p className="text-sm text-white/60 mt-1">
            This number will be added to your CIVIX account at no charge during the testing period.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="a2p-bypass-banner"
      className="panel p-5 flex items-start gap-3 border-emerald-500/30 bg-emerald-500/5"
    >
      <ShieldCheck className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
      <div>
        <div className="font-semibold">SMS sending is enabled</div>
        <p className="text-sm text-white/60 mt-1">
          This account uses CIVIX's verified A2P registration. SMS sending is enabled. No setup required.
        </p>
      </div>
    </div>
  );
}
